import { useState } from 'react';

import { type UserTargetingProps } from 'hb-react/frontoffice/components/user_targeting/types';
import { UjTeamErrorBoundary } from 'hb-react/shared/components/ErrorBoundary';

import { NotifyPeopleModal } from './NotifyPeopleModal';

export const NotifyPeopleModalRoot = ({
  renderTriggerElement,
  ...props
}: UserTargetingProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      {renderTriggerElement?.(handleOpen)}

      {isOpen && (
        <UjTeamErrorBoundary app="fo" module="notify_people">
          <NotifyPeopleModal setIsOpen={setIsOpen} {...props} />
        </UjTeamErrorBoundary>
      )}
    </>
  );
};
